var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8333 8.33337H14V5.83337C14 3.08337 11.75 0.833374 9 0.833374C6.25 0.833374 4.00001 3.08337 4.00001 5.83337V8.33337H3.16667C1.75001 8.33337 0.666672 9.41671 0.666672 10.8334V16.6667C0.666672 18.0834 1.75001 19.1667 3.16667 19.1667H14.8333C16.25 19.1667 17.3333 18.0834 17.3333 16.6667V10.8334C17.3333 9.41671 16.25 8.33337 14.8333 8.33337ZM5.66667 5.83337C5.66667 4.00004 7.16667 2.50004 9 2.50004C10.8333 2.50004 12.3333 4.00004 12.3333 5.83337V8.33337H5.66667V5.83337ZM14.8333 17.5C15.3333 17.5 15.6667 17.1667 15.6667 16.6667V10.8334C15.6667 10.3334 15.3333 10 14.8333 10H3.16667C2.66667 10 2.33334 10.3334 2.33334 10.8334V16.6667C2.33334 17.1667 2.66667 17.5 3.16667 17.5H14.8333Z",
    fill: "#515151"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.db759eede6e54b8bc7adfd09fce7c729.svg";
export { ForwardRef as ReactComponent };